// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_P-aJe","href":"index_href_hJwEN"};